import { DataHighlight, Flex, Image, useMediaQuery } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { styled } from "styled-components";
import { SecondaryPanelContentLayout } from "shared-ui";

import { MESSAGES } from "./message-definitions";

const logos = [
  { src: "/fly-assets/logos/jp-morgan-logo.svg", alt: "JP Morgan logo" },
  { src: "/fly-assets/logos/atlas-sp-logo.svg", alt: "Atlas SP logo" },
];

const LogoImg = styled(Image)`
  max-width: 200px;
`;

export const FundingPartnersPanel = () => {
  const query = useMediaQuery();
  const alignment = query("xs").windowLte ? "center" : "flex-start";
  const intl = useIntl();

  // margin-bottom is added to space out the Wayflyer logo at bottom from the "backed by" logos above
  return (
    <SecondaryPanelContentLayout>
      <Flex gap="8" direction="column" align={alignment} width="100%" margin={["0", "0", "16", "0"]}>
        <DataHighlight color="onDark">{intl.formatMessage(MESSAGES.backedBy)}</DataHighlight>
        {logos.map((logo, index) => (
          <LogoImg key={index} src={logo.src} alt={logo.alt} />
        ))}
      </Flex>
    </SecondaryPanelContentLayout>
  );
};
